import Cookies from 'js-cookie'
import axios from 'axios'
import { useAuthStore } from './store'

const AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL
const AUTH_COOKIES_DOMAIN = process.env.REACT_APP_AUTH_COOKIES_DOMAIN

export function parseJWT(token: string) {
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch (e) {
    return null
  }
}

function setAuthCookie(name: string, value: string) {
  Cookies.set(name, value, {
    domain: AUTH_COOKIES_DOMAIN,
    path: '/',
  })
}

export function setVerifiedUser() {
  const accessToken = Cookies.get('miigu__auth__access_token')

  if (!accessToken) {
    return
  }

  return axios
    .post(`${AUTH_BASE_URL}/api/token/verify/`, { token: accessToken })
    .then(() => {
      const { email, first_name_ru, last_name_ru } = parseJWT(Cookies.get('miigu__auth__access_token')!)
      useAuthStore.getState().setUser({ email, first_name_ru, last_name_ru })
    })
}

export function refreshToken() {
  const refreshToken = Cookies.get('miigu__auth__refresh_token')

  if (!refreshToken) {
    return Promise.resolve()
  }

  return axios
    .post(`${AUTH_BASE_URL}/api/token/refresh/`, { refresh: refreshToken })
    .then(response => {
      setAuthCookie('miigu__auth__access_token', response.data['access'])
    })
}

export function redirectToAuth() {
  window.location.replace(`${AUTH_BASE_URL}/?back_to=${btoa(window.location.href)}&force=1`)
}

export function trackLogout() {
  useAuthStore.subscribe((state, prevState) => {
    if (prevState.user && !state.user) {
      Cookies.remove('miigu__auth__access_token', { domain: AUTH_COOKIES_DOMAIN })
      Cookies.remove('miigu__auth__refresh_token', { domain: AUTH_COOKIES_DOMAIN })
      window.location.reload()
    }
  })
}